import { render } from "./AgentToggle.vue?vue&type=template&id=661da68c&scoped=true"
import script from "./AgentToggle.vue?vue&type=script&lang=js"
export * from "./AgentToggle.vue?vue&type=script&lang=js"

import "./AgentToggle.vue?vue&type=style&index=0&id=661da68c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661da68c"]])

export default __exports__